export const useSiteURL = () => useState<string>("siteUrl", () => "");

export const useSiteTitle = () => useState<string>("siteTitle", () => "");

export const useSiteWeb = () => useState<string>("siteWeb", () => "");

export const useSiteApp = () => useState<string>("siteApp", () => "");